module.exports = __webpack_public_path__ + "1e67dabbebb7dd1ee9562facc7c0de83.woff2";